import { DEFAULT_TIMEZONE } from '../constants/apiConstants';

export const validTimezoneOrDefault = (
    timeZone?: string,
    defaultTimezone: string = DEFAULT_TIMEZONE,
): string => {
    // There is no function to test if a timezone string is valid.  So a workaround
    // is to pass in the timeZone into a function and see if it changes it or throws an error.  If
    // it throws an error, we know that the timeZone is bad.
    try {
        // Since we are just testing a timezone, we don't care about the locale.
        const usedOptions = new Intl.DateTimeFormat(undefined, { timeZone }).resolvedOptions();
        // If Intl changes the timeZone, return the standardized timezone.
        if (timeZone !== usedOptions.timeZone) {
            return usedOptions.timeZone || defaultTimezone;
        }
        return timeZone || defaultTimezone;
    } catch (ex) {
        // If the timezone is bad, then return the defaultTimezone.
        return defaultTimezone;
    }
};
